import { useState, useRef, Dispatch, SetStateAction } from 'react'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Floppy2Fill } from 'react-bootstrap-icons';
import context from './context/shared';
import { centerClient } from '../../shared/clients';
import type { Client, Client as ClientDto } from '../../shared/generated';
import { Col, Modal, Row } from 'react-bootstrap';
import { useIsMobile } from '../shared';
import { toast } from 'react-toastify';
import { observer } from 'mobx-react-lite';
import { useBackButton } from '../../utils/backButton';
interface IClientInfoProps {
    client: ClientDto;
    setClient: Dispatch<SetStateAction<ClientDto>>;
}

const ClientInfo = (props: IClientInfoProps) => {
    const { client, setClient } = props;
    const saveTimeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [saveText, setSaveText] = useState("");
    const { refreshTree } = context;

    const isMobile = useIsMobile();

    const handleSaveClient = (clientToSave) => {
        setSaveText("");
        setSaveButtonDisabled(false);
        clearTimeout(saveTimeoutRef.current);        
        saveTimeoutRef.current = setTimeout(() => {
            saveClient(clientToSave);
        }, 1000);
    }
    const saveClient = (clientToSave: Client) => {
        centerClient.updateClient(clientToSave)
            .then(() => {
                setSaveButtonDisabled(true);
                setSaveText("Сохранено");
                refreshTree();
                if (isMobile)
                    toast.success("Настройки клиента успешно сохранены");
            })
            .catch(() => void 0);
    }
    const handleCheckbox = (evt) => {
        const name = evt.target.id;
        const checked = evt.target.checked;
        const newClient = { ...client } as Client;
        newClient[name] = checked;
        setClient(newClient);
        handleSaveClient(newClient);
    }
    const handleDefaultDealerCost = (evt) => {
        const value = evt.target.value;
        const newClient = { ...client } as Client;
        newClient.DefaultDealerCost = value;
        setClient(newClient);
        handleSaveClient(newClient);
    }
    const handleClient = (evt) => {
        const name = evt.target.name;
        const val = evt.target.value;
        const newClient = { ...client } as Client;
        newClient[name] = val;
        setClient(newClient);
        handleSaveClient(newClient);
    }
    const handleSaveButton = () => {
        clearTimeout(saveTimeoutRef.current);        
        saveClient(client);
    }
    return <>
        {
            isMobile ? <Mobile client={client} setClient={setClient} saveClient={saveClient } /> :
                <div style={{ marginBottom: ".5rem" }} >
                    <div style={{ display: 'flex', gap: 5, marginBottom: 5, alignItems: 'flex-end' }} >
                        <div>
                            <Form.Label>Номер</Form.Label>
                            <Form.Control className="disabled" type="input" name="Id" onChange={handleClient} value={client.Id} disabled={true} placeholder="Номер..." /> 
                        </div>
                        <div>
                            <Form.Label>Имя</Form.Label>
                            <Form.Control type="input" name="Name" onChange={handleClient} value={client.Name} placeholder="Имя..." />
                        </div>
                        <div>
                            <Form.Label>Комментарий</Form.Label>
                            <Form.Control type="input" name="Comment" onChange={handleClient} value={client.Comment} placeholder="Комментарий..." />
                        </div>
                        <div>
                            <Button onClick={handleSaveButton} variant="transparent" className={saveButtonDisabled ? "disabled" : ""}>
                                <Floppy2Fill style={{ fill: 'var(--text)' }} />
                            </Button>
                            <label style={{ marginLeft: "1rem" }}>{saveText}</label>
                        </div>
                    </div>

                <div style={{ display: "flex" }}>
                    <div>
                        <Form.Group>
                            <Form.Check type="checkbox" id="IsClientBlocked" onChange={handleCheckbox} label="Блокировать выдачу данных клиенту" checked={client.IsClientBlocked} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check type="checkbox" id="IsDealerBlocked" onChange={handleCheckbox} label="Запрет на редактирование в дилерском приложении" checked={client.IsDealerBlocked} />
                        </Form.Group>
                        <Form.Group style={{ display: 'flex', alignItems: 'center' }} >
                            <Form.Label>Цена дилера по умолчанию</Form.Label>
                            <Form.Control style={{ width: '6rem', marginLeft: '1rem' }} type="number" value={client.DefaultDealerCost} onChange={handleDefaultDealerCost} />
                        </Form.Group>
                        {/*<Form.Group>*/}
                        {/*    <Form.Check type="checkbox" id="IsMultiDealer" value={client.IsMultiDealer}  onChange={handleCheckbox} label="Мультидилер" checked={client.IsMultiDealer} />*/}
                        {/*</Form.Group>*/}
                    </div>
                    <div style={{ marginLeft: "1rem" }}>
                        <Form.Group style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Form.Label>Логин</Form.Label>
                            <Form.Control style={{ marginLeft: ".5rem", width: "calc(100% - 4rem)" }} type="input" name="Login" onChange={handleClient} value={client.Login} />
                        </Form.Group>
                        <Form.Group style={{ marginTop: ".5rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Form.Label>Пароль</Form.Label>
                            <Form.Control style={{ marginLeft: ".5rem", width: "calc(100% - 4rem)" }} type="input" name="Password" onChange={handleClient} value={client.Password} />
                        </Form.Group>
                    </div>
                </div>
            </div>
        }
    </>

};

interface IClientInfoMobileProps {
    client: Client;
    setClient: Dispatch<SetStateAction<Client>>;
    saveClient: (client: Client) => void;
}

const Mobile = observer((props: IClientInfoMobileProps) => {
    const { client, setClient, saveClient } = props;
    const { showClientSettings, setShowClientSettings } = context;
    const handleClient = (evt) => {
        const name = evt.target.name;
        const val = evt.target.value;
        const newClient = { ...client } as Client;
        newClient[name] = val;
        setClient(newClient);
    }
    const handleCheckbox = (evt) => {
        const name = evt.target.id;
        const checked = evt.target.checked;
        const newClient = { ...client } as Client;
        newClient[name] = checked;
        setClient(newClient);
    }
    const save = () => {
        saveClient(client);
    }
    const handleClose = () => setShowClientSettings(false);
    useBackButton(handleClose, showClientSettings);
    return (
        <>
            <Modal show={showClientSettings} onHide={handleClose} className="mobileBottomSheet" >
                <Modal.Header closeButton>
                    <Modal.Title>Настройки клиента</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Номер</Form.Label>
                                    <Form.Control className="disabled" type="input" value={client.Id} disabled={true} placeholder="Номер..." />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Имя</Form.Label>
                                    <Form.Control type="input" name="Name" onChange={handleClient} value={client.Name} placeholder="Имя..." />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Логин</Form.Label>
                                    <Form.Control type="input" name="Login" onChange={handleClient} value={client.Login} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Пароль</Form.Label>
                                    <Form.Control type="input" name="Password" onChange={handleClient} value={client.Password} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Ц.Д по умолчанию</Form.Label>
                                    <Form.Control name="DefaultDealerCost" type="number" value={client.DefaultDealerCost} onChange={handleClient} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-2">
                                    <Form.Label>Комментарий</Form.Label>
                                    <Form.Control type="input" name="Comment" onChange={handleClient} value={client.Comment} placeholder="Комментарий..." />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group>
                                    <Form.Check type="checkbox" id="IsClientBlocked" onChange={handleCheckbox} label="Блокировать выдачу данных клиенту" checked={client.IsClientBlocked} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Check type="checkbox" id="IsDealerBlocked" onChange={handleCheckbox} label="Запрет на редактирование в дилерском приложении" checked={client.IsDealerBlocked} />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem', marginTop: '.5rem' }}>
                        <div style={{ display: 'flex', gap: '.5rem' }}>
                            <Button variant="custom" onClick={save}>
                                <Floppy2Fill className="marginRight" />
                                Сохранить
                            </Button>
                            <Button variant="custom" onClick={handleClose}>
                                Закрыть
                            </Button>
                        </div>
                    </div>

                </Modal.Footer>
            </Modal>
        </>
    )
});

export default ClientInfo;
